import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";

import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { ReactElement, ReactNode } from "react";
import { LoaderIcon } from "react-hot-toast";
import { cn } from "utils/ui";

interface Props {
  children?: ReactNode;
  header: string | ReactElement;
  isLoading?: boolean;
  defaultOpen?: boolean;
}

export default function Collapse({ children, header, isLoading = false, defaultOpen = false }: Props) {
  return (
    <Disclosure defaultOpen={defaultOpen}>
      {({ open }) => (
        <>
          <DisclosureButton
            as="div"
            data-test="btn-collapse"
            className={cn({ "cursor-pointer": !isLoading }, "text-color-primary w-full")}
          >
            <div className="flex flex-row space-x-4">
              <div className="flex flex-col justify-around">
                {isLoading ? (
                  <LoaderIcon className="size-5" data-icon="LoaderIcon" />
                ) : (
                  <ChevronRightIcon data-icon="ChevronRightIcon" className={cn({ "rotate-90": open }, "size-5")} />
                )}
              </div>
              {header}
            </div>
          </DisclosureButton>
          <DisclosurePanel>{children}</DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
}
